module.exports = __webpack_public_path__ + "static/media/title_12.a845954f.svg";